
import { defineComponent } from "vue";

export default defineComponent({
  name: "sortingArrow",
  props: {
    isOrderAsc: Boolean
  }
});
